import { render } from "./ModalRepresentados.vue?vue&type=template&id=e1f9d67e&scoped=true&ts=true"
import script from "./ModalRepresentados.vue?vue&type=script&lang=ts"
export * from "./ModalRepresentados.vue?vue&type=script&lang=ts"

import "./ModalRepresentados.vue?vue&type=style&index=0&id=e1f9d67e&lang=scss&scoped=true"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1f9d67e"]])

export default __exports__